import React from "react";
import AccountsListPage, { fmtDate, orDash } from "./AccountsShared";

export const AccountsAuditLogs = () => (
  <AccountsListPage title="Audit Logs" subtitle="Critical actions and approvals." endpoint="/employee/accounts/audit-logs"
    columns={[{ key: "module", label: "Module" }, { key: "action", label: "Action" }, { key: "user", label: "User", render: (r) => orDash(r.user?.fullName || r.user?._id || r.user) }, { key: "createdAt", label: "Date", render: (r) => fmtDate(r.createdAt) }, { key: "meta", label: "Details", render: (r) => <code>{JSON.stringify(r.meta || {})}</code> }]}
    createPerms={["__never__"]} approvePerms={["__never__"]} />
);
